import { obterQrDoProduto } from '../../api/produtos.js';
import type { QrDoProduto } from '../../api/produtos.js';
import type { EstadoDoQrDe, QrsPorCodigo } from './useQrPorCodigo.js';
import { useQrPorCodigo } from './useQrPorCodigo.js';

/** O que se sabe do QR de um produto da lista (ver `useQrPorCodigo`). */
export type EstadoDoQr = EstadoDoQrDe<QrDoProduto>;

export type QrDosProdutos = QrsPorCodigo<QrDoProduto>;

/**
 * Pede ao middleware a matriz de cada `codPro` da lista, uma vez por código.
 *
 * Tirar um código da lista não descarta a matriz já obtida: se ele voltar, a
 * etiqueta reaparece sem nova ida ao servidor. Falha fica no próprio código —
 * um produto recusado não impede os outros de imprimirem.
 */
export function useQrDosProdutos(codigos: readonly string[]): QrDosProdutos {
  return useQrPorCodigo(codigos, obterQrDoProduto);
}
